import React, {Component} from "react";
import {Alert, Modal, Button} from "reactstrap";
import {withTranslation} from "react-i18next";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {confirmModalAction} from "../../store/components/confirmModal/actions";

class ConfirmModal extends Component {
  constructor(props) {
    super(props)
    this.state = {loading: false, error: ""}
  }

  onClose = () => {
    this.props.togModal()
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({loading: this.props.loading, response: this.props.response, error: this.props.error});
      if (this.props.response && this.props.response.status === 0) {
        this.props.refreshParent()
        this.onClose()
      }
    }
  }

  render() {
    return (<React.Fragment>
      <Modal isOpen={true} toggle={this.onClose}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            {this.props.title}
          </h5>
          <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div className="modal-body">
          {this.props.question}
        </div>
        <div className="modal-footer">
          {this.state.loading && (<div className="spinner-border text-primary m-1 me-auto" role="status">
            <span className="sr-only">Loading...</span>
          </div>)}
          {this.state.error.length > 0 && (<Alert color="danger" role="alert" className="me-auto">
            {this.state.error}
          </Alert>)}
          <Button color="secondary" onClick={this.onClose} data-dismiss="modal">
            Close
          </Button>
          <Button color={this.props.actionColor} onClick={() => this.props.onConfirmModalAction({call: this.props.call, data: {...this.props.actionData, history: this.props.history}})}>
            {this.props.actionName}
          </Button>
        </div>
      </Modal>
    </React.Fragment>)
  }
}

ConfirmModal.propTypes = {
  response: PropTypes.any,
  onConfirmModalAction: PropTypes.func,
};

const mapStateToProps = ({ConfirmModal}) => ({
  response: ConfirmModal.responseAction,
  loading: ConfirmModal.loadingAction,
  error: ConfirmModal.errorAction,
});

const mapDispatchToProps = dispatch => ({
  onConfirmModalAction: data => dispatch(confirmModalAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ConfirmModal));
